<se-fe-chip-group>
  <se-fe-chip
    [seFeTestId]="{ label: 'DateChip', isRoot: true }"
    [seFeDataText]="'DISCOUNTS.LIST_VIEW.FILTERS.date' | translate"
    [seFeDataAriaLabel]="'DISCOUNTS.LIST_VIEW.FILTERS.date_filter' | translate"
    seFeDataIconRight="chevron_down"
    [seFeDataSelected]="!!selectedFilter()"
    [seFeDataDisabled]="disabled()"
    [seFeMenuTrigger]="dateMenu"
    (seFeClick)="onMenuOpened()"></se-fe-chip>

  <se-fe-menu-filter #dateMenu class="date-filter-menu" [seFeDataOptions]="dateMenuOptions">
    <div seFeMenuContent>
      <form [formGroup]="form" novalidate>
        <se-fe-radios formControlName="quickFilter" [seFeDataOptions]="radioOptions"></se-fe-radios>

        @if (form.controls.quickFilter.value === 'date-range') {
          <div class="specific-date-range-section">
            <se-fe-grid seFeGridOpts="snug">
              <se-fe-grid-cell seFeGridOpts="1/2">
                <se-fe-datepicker
                  formControlName="startDate"
                  [seFeDataLabel]="'DISCOUNTS.LIST_VIEW.FILTERS.start_date' | translate"
                  [seFeDataExcludeDates]="datepickerLimit"
                  [seFeDataYearRange]="{ future: 0, past: 10 }"
                  [seFeDataMessages]="datepickerMessages"></se-fe-datepicker>
              </se-fe-grid-cell>
              <se-fe-grid-cell seFeGridOpts="1/2">
                <se-fe-datepicker
                  formControlName="endDate"
                  [seFeDataLabel]="'DISCOUNTS.LIST_VIEW.FILTERS.end_date' | translate"
                  [seFeDataExcludeDates]="datepickerLimit"
                  [seFeDataYearRange]="{ future: 0, past: 10, sort: 'desc' }"
                  [seFeDataMessages]="datepickerMessages"></se-fe-datepicker>
              </se-fe-grid-cell>
            </se-fe-grid>
            @if (errors.length) {
              <se-fe-form-control-errors
                [seFeDataMessages]="errorMessages"
                [seFeDataErrors]="errors"></se-fe-form-control-errors>
            }
          </div>
        }
      </form>
    </div>
  </se-fe-menu-filter>
</se-fe-chip-group>
